import { render, staticRenderFns } from "./HIcon.vue?vue&type=template&id=0271c081&scoped=true&"
import script from "./HIcon.vue?vue&type=script&lang=js&"
export * from "./HIcon.vue?vue&type=script&lang=js&"
import style0 from "./HIcon.vue?vue&type=style&index=0&id=0271c081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271c081",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0271c081')) {
      api.createRecord('0271c081', component.options)
    } else {
      api.reload('0271c081', component.options)
    }
    module.hot.accept("./HIcon.vue?vue&type=template&id=0271c081&scoped=true&", function () {
      api.rerender('0271c081', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HIcon.vue"
export default component.exports